
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as custom_45warehouse_45management_45systemB2a5WaSDx4QfAtjHzNfcIft5CS2ckkuAWxKkvxAfv1EMeta } from "/app/web/app/pages/logistics/custom-warehouse-management-system.vue?macro=true";
import { default as _91slug_93eyvBpLImy1gMntEg9WBMvY3FMFMGBIZrBftuLDPasH0Meta } from "/app/web/app/pages/projects/[industry]/[slug].vue?macro=true";
import { default as _91slug_93FQV9HJcxTm5KSVMlaJSH7rNSNKMqTnfLGEVxK4o1h4YMeta } from "/app/web/app/pages/blog/[slug].vue?macro=true";
import { default as _91slug_93SYB4P25hQxFyJ6fnU8O_QeqEohU3utMNzU13MaTJsQkMeta } from "/app/web/app/pages/careers/[slug].vue?macro=true";
import { default as _91slug_939nJDVsdHcgZl2Qi6UOvcw47Y60epLdRrd4hZ3jnFh7wMeta } from "/app/web/app/pages/free-resources/[slug].vue?macro=true";
import { default as _91slug_93PLXcS88mn1C7l94ePwLXLH4W_foiZ5QjiHhiSgf_C2EMeta } from "/app/web/app/pages/gazette/[slug].vue?macro=true";
import { default as index8TBnlmR4VUibRB6uXEfAe7ePXolJAbLhC3HPzq7hTp4Meta } from "/app/web/app/pages/projects/[industry]/index.vue?macro=true";
import { default as _91slug_93cxSB1UBWnP97WxGE9grmTD8Uyy9DmTpWCpDlXzdGZqMMeta } from "/app/web/app/pages/tech/[slug].vue?macro=true";
import { default as _91slug_93SlRlTuKam3PHiHM25081jft9yrnEqAERx3yILNbMjUEMeta } from "/app/web/app/pages/technical-bytes/[slug].vue?macro=true";
import { default as indexLGTyimrAhULT66aqxJ_K4j6_3Ut1x4lhd3WE4yDPmR4Meta } from "/app/web/app/pages/blog/index.vue?macro=true";
import { default as brandDY1SVoSbEsUFso51an713CjA4q7jhqYG7LnBIXJsGrMMeta } from "/app/web/app/pages/brand.vue?macro=true";
import { default as indexWq5OIGmc5qZY69G9LkKyPL6Mo2Gm_xN9H_mxI3o5MRkMeta } from "/app/web/app/pages/careers/index.vue?macro=true";
import { default as companyAlZ0XoWoLUq2Gbddd1mVDmQ1kkp4VUYB_1lOP_hPm2QMeta } from "/app/web/app/pages/company.vue?macro=true";
import { default as contact0d8zLd8NVwK8Y2vaqYkDAEj9JW2P2JiF9HPy8AFvdr0Meta } from "/app/web/app/pages/contact.vue?macro=true";
import { default as custom_45healthcare_45software_45developmentAEFa8sewXcyTbbvOgzU_0W98sHFTjJcH_Jsic_CXYG4Meta } from "/app/web/app/pages/custom-healthcare-software-development.vue?macro=true";
import { default as dedicated_45team6ktovhy18f56gcQ3UHzgTMSULlgOpvr_yQbTbm_dS4oMeta } from "/app/web/app/pages/dedicated-team.vue?macro=true";
import { default as indexSY_jKO5OjdwViBM3UXzMArs4kll7th5TkZlwiQgJvN8Meta } from "/app/web/app/pages/free-resources/index.vue?macro=true";
import { default as indexKdFx9Mw2_Ff2DTHafAXmLBPixgtBa4UH7FQ_g395ZSQMeta } from "/app/web/app/pages/gazette/index.vue?macro=true";
import { default as impressumEc6wyefyDuukp1gS887k4vja3ois54GoI0pQRF_0iYcMeta } from "/app/web/app/pages/impressum.vue?macro=true";
import { default as indexpodm9PEHlCtB18ainnNPXJI_1_OmlXtDg8wEBYXoMcwMeta } from "/app/web/app/pages/logistics/index.vue?macro=true";
import { default as managed_45projects0Y1uzVxXahc_V_twfPrlLexJVgi9ZGGXz_d5iHu3d0kMeta } from "/app/web/app/pages/managed-projects.vue?macro=true";
import { default as product_45discovery_45workshoplsM8o4sjGutFd0DialoYcs75bsRDs7roKkswtugGKb8Meta } from "/app/web/app/pages/product-discovery-workshop.vue?macro=true";
import { default as indexYLtAgFqIJkfwL_0z1B63tFy68cDdJbnIx_GYo2x_qD8Meta } from "/app/web/app/pages/projects/index.vue?macro=true";
import { default as servicesupRD2JE9pIDrNKwsh4aWOkh1U5sKfnY5mDOaWTepf8AMeta } from "/app/web/app/pages/services.vue?macro=true";
import { default as startupspmzGFPH3ynLHLL92Ve1aoCURnYBM_jv1g2iSsx6JHzEMeta } from "/app/web/app/pages/startups.vue?macro=true";
import { default as indexrNhLOVt2VJtjatJ9CoFroa40QY9tZFw_KS4xOoaQxIkMeta } from "/app/web/app/pages/technical-bytes/index.vue?macro=true";
import { default as _91slug_93Howgg71aFQIOUdmhxmf5jQhisQw4zSIgNFF2lVP4VIoMeta } from "/app/web/app/pages/[slug].vue?macro=true";
import { default as index65Jx60L5prBdZYOeUCMlh4HLKXre0eeBekoSATScb10Meta } from "/app/web/app/pages/index.vue?macro=true";
import { default as component_45stubR1lahljCOCpvYaiA3B7hTtST3Yc_qAGu2DyKYb8JAicMeta } from "/app/node_modules/.pnpm/nuxt@4.4.6_@babel+plugin-syntax-jsx@7.28.6_@babel+core@7.29.0__@babel+plugin-syntax-typ_0b360edd61f563c00224835085f0b017/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubR1lahljCOCpvYaiA3B7hTtST3Yc_qAGu2DyKYb8JAic } from "/app/node_modules/.pnpm/nuxt@4.4.6_@babel+plugin-syntax-jsx@7.28.6_@babel+core@7.29.0__@babel+plugin-syntax-typ_0b360edd61f563c00224835085f0b017/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "logistics-custom-warehouse-management-system___en",
    path: "/logistics/custom-warehouse-management-system",
    component: () => import("/app/web/app/pages/logistics/custom-warehouse-management-system.vue")
  },
  {
    name: "projects-industry-slug___en",
    path: "/projects/:industry()/:slug()",
    component: () => import("/app/web/app/pages/projects/[industry]/[slug].vue")
  },
  {
    name: "blog-slug___en",
    path: "/blog/:slug()",
    component: () => import("/app/web/app/pages/blog/[slug].vue")
  },
  {
    name: "careers-slug___en",
    path: "/careers/:slug()",
    component: () => import("/app/web/app/pages/careers/[slug].vue")
  },
  {
    name: "free-resources-slug___en",
    path: "/free-resources/:slug()",
    component: () => import("/app/web/app/pages/free-resources/[slug].vue")
  },
  {
    name: "gazette-slug___en",
    path: "/gazette/:slug()",
    component: () => import("/app/web/app/pages/gazette/[slug].vue")
  },
  {
    name: "projects-industry___en",
    path: "/projects/:industry()",
    component: () => import("/app/web/app/pages/projects/[industry]/index.vue")
  },
  {
    name: "tech-slug___en",
    path: "/tech/:slug()",
    component: () => import("/app/web/app/pages/tech/[slug].vue")
  },
  {
    name: "technical-bytes-slug___en",
    path: "/technical-bytes/:slug()",
    component: () => import("/app/web/app/pages/technical-bytes/[slug].vue")
  },
  {
    name: "blog___en",
    path: "/blog",
    component: () => import("/app/web/app/pages/blog/index.vue")
  },
  {
    name: "brand___en",
    path: "/brand",
    component: () => import("/app/web/app/pages/brand.vue")
  },
  {
    name: "careers___en",
    path: "/careers",
    component: () => import("/app/web/app/pages/careers/index.vue")
  },
  {
    name: "company___en",
    path: "/company",
    component: () => import("/app/web/app/pages/company.vue")
  },
  {
    name: "contact___en",
    path: "/contact",
    component: () => import("/app/web/app/pages/contact.vue")
  },
  {
    name: "custom-healthcare-software-development___en",
    path: "/custom-healthcare-software-development",
    component: () => import("/app/web/app/pages/custom-healthcare-software-development.vue")
  },
  {
    name: "dedicated-team___en",
    path: "/dedicated-team",
    component: () => import("/app/web/app/pages/dedicated-team.vue")
  },
  {
    name: "free-resources___en",
    path: "/free-resources",
    component: () => import("/app/web/app/pages/free-resources/index.vue")
  },
  {
    name: "gazette___en",
    path: "/gazette",
    component: () => import("/app/web/app/pages/gazette/index.vue")
  },
  {
    name: "impressum___en",
    path: "/impressum",
    component: () => import("/app/web/app/pages/impressum.vue")
  },
  {
    name: "logistics___en",
    path: "/logistics",
    component: () => import("/app/web/app/pages/logistics/index.vue")
  },
  {
    name: "managed-projects___en",
    path: "/managed-projects",
    component: () => import("/app/web/app/pages/managed-projects.vue")
  },
  {
    name: "product-discovery-workshop___en",
    path: "/product-discovery-workshop",
    component: () => import("/app/web/app/pages/product-discovery-workshop.vue")
  },
  {
    name: "projects___en",
    path: "/projects",
    component: () => import("/app/web/app/pages/projects/index.vue")
  },
  {
    name: "services___en",
    path: "/services",
    component: () => import("/app/web/app/pages/services.vue")
  },
  {
    name: "startups___en",
    path: "/startups",
    component: () => import("/app/web/app/pages/startups.vue")
  },
  {
    name: "technical-bytes___en",
    path: "/technical-bytes",
    meta: indexrNhLOVt2VJtjatJ9CoFroa40QY9tZFw_KS4xOoaQxIkMeta || {},
    component: () => import("/app/web/app/pages/technical-bytes/index.vue")
  },
  {
    name: "slug___en",
    path: "/:slug()",
    component: () => import("/app/web/app/pages/[slug].vue")
  },
  {
    name: "index___en",
    path: "/",
    component: () => import("/app/web/app/pages/index.vue")
  },
  {
    name: component_45stubR1lahljCOCpvYaiA3B7hTtST3Yc_qAGu2DyKYb8JAicMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubR1lahljCOCpvYaiA3B7hTtST3Yc_qAGu2DyKYb8JAic
  }
]